import loading from "./loader";
import uploadEnQueueFiles from "./upload";
import Share from "./share.js";
import Root from "./root";

export default {
	loading,
	uploadEnQueueFiles,
	Share,
	Root
};
